
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game, Auth } from '../../../../Core'
import * as firebaseSelectors from '../../../../Core/Firebase/firebase.selectors'
import Counter from '../../../Components/Counter'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

class Welcome2 extends React.Component {
  constructor(props) {
    super(props)
  }
  videoAndNext() {
    const { startSceneChange, next, addHowlSound } = this.props
    addHowlSound('button_click')
    startSceneChange('trailer_scene')
    next()
  }
  render() {
    const { groupData, user } = this.props
    const turns = groupData.maxTurns
    const topic = groupData.topic || user.licenseData.topic ? user.licenseData.topic : ''
    const sessions = groupData.sessions ? groupData.sessions : 6
    // const duration = groupData.sessionDuration ? Math.round(parseFloat(groupData.sessionDuration) * 10) / 10  : '30'
    const dateTime = groupData.endSessionDate
    let durationTypeTurn =
      turns == 1 ? 'welcome.sessionDurationMessageOneTurn' : 'welcome.sessionDurationMessage'
    let durationTypeSession = sessions == 1 ? 'welcome.session' : 'welcome.sessions'
    return (
      <div className="container background background--mars">
        <div className="content">
          <div className="mars--init">
            <div className="mars--logo__company"></div>
            <div className="mars--logo"></div>
            <div className="mars--init__info">
              <span className="mars--init__title">
                <FormattedMessage id="welcome.topic" />
              </span>
              <div className="mars--init__topic">{topic}</div>
              <div className="mars--init__subtitle">
                <FormattedMessage id="welcome.message1" />
              </div>
              <div className="mars--info">
                <div className="mars--info__canvas">
                  <ul className="mars--info__list">
                    <li className="mars--info__list--item">
                      <div className="value">{sessions}</div>
                      <div className="title font--bold">
                        <b>
                          <FormattedMessage id={durationTypeSession} />
                        </b>
                      </div>
                      <span className="text text--center">
                        <FormattedMessage
                          id="welcome.endSessionMessage"
                          values={{ sessionEnd: '' }}
                        />
                      </span>
                      <span className="text font--bold">
                        <Counter dateTime={dateTime} countdown={true} />
                      </span>
                    </li>
                    <li className="mars--info__list--item">
                      <div className="value">{turns}</div>
                      <div className="title font--bold">
                        <FormattedMessage id={durationTypeTurn} />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div onClick={() => this.videoAndNext()} className="btn--orange">
                <span className="icon-rocket"></span>
                <span>
                  <FormattedMessage id={'welcome.start'} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    user: Auth.selectors.getUserInfo(state),
    groupData: firebaseSelectors.getGroupData(state),
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    startSceneChange: bindActionCreators(Game.actions.startSceneChange, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  }
}

Welcome2.propTypes = {
  next: PropTypes.func,
  startSceneChange: PropTypes.func,
  groupData: PropTypes.object,
  user: PropTypes.object,
  addHowlSound: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Welcome2))
